module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/465p5v/tc-custom/9781488063190.jpg?1727649798755",
      "alt": "This image is the cover for the book High Society Secrets, The Sterling Wives"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("High Society Secrets, The Sterling Wives\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Their sizzling chemistry could burn them both!")]), _c('br'), _c('br'), _vm._v("What clashes in the boardroom combusts in the bedroom! Working at her late ex-husband’s company, socialite Astrid Sterling finds new purpose. If only star architect Clay Morgan would give her a chance instead of the cold shoulder. But a truce that explodes into blinding passion leaves Astrid breathless—and torn. The single dad already has trust issues—and Astrid has a secret that could shatter everything they’ve built…"), _c('br'), _c('br'), _c('b', [_vm._v("From Harlequin Desire: "), _c('i', [_vm._v("A luxurious world of bold encounters and sizzling chemistry.")]), _c('br'), _c('br'), _vm._v("The Sterling Wives")]), _c('br'), _vm._v("Book 1: "), _c('i', [_vm._v("Once Forbidden, Twice Tempted")]), _c('br'), _vm._v("Book 2: "), _c('i', [_c('i', [_vm._v("High Society Secrets")])]), _c('br'), _vm._v("Book 3: "), _c('i', [_c('i', [_vm._v("All He Wants for Christmas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karen Booth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Karen Booth is a Midwestern girl transplanted in the South, raised on '80s music and way too many readings of “Forever” by Judy Blume. Married to her real-life Jake Ryan, she has two amazing kids with epic hair, a very bratty cat, and loves getting up before dawn to write romance. With plenty of sparks.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0